import { Component, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-create-form-recurring-type',
  templateUrl: './create-form-recurring-type.component.html',
  styleUrls: ['./create-form-recurring-type.component.scss']
})
export class CreateFormRecurringTypeComponent implements OnInit, ControlValueAccessor {

  constructor(public ngControl: NgControl) { 
    ngControl.valueAccessor = this;
  }

  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}

  ngOnInit(): void {
  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  changeRecurringType(value: boolean){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

}
